<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gSUu0f/tc-custom/9781524853044.jpg?1701477017946" alt="This image is the cover for the book So Who's Counting?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">So Who's Counting?
      </h1>
      <p class="bookDescription body article font2">
        <b>Inspiring quotes and advice to help readers see getting older as a time for reinvention and personal growth.</b><br/><br/>“Aging is an extraordinary process where you become the person you should have been.” —David Bowie<br/><br/> So long nostalgia, and goodbye resignation! This book of quotes reminds us that growing old isn’t about slowing down and taking it easy—it’s a chance to ask, “What’s next?”  After all, sixty is the new fifty, seventy’s the new sixty, and older is getting younger every day. With fun, forward-looking, and inspiring wisdom, <i>So Who’s Counting?</i> is the ideal gift for baby boomers, Gen Xers or anyone reaching a major age milestone. Instead of cloying sentimentality or the standard sagging-body-part jokes, it strikes the perfect balance of humor, guidance, reflection, bon mots. Quotes are divided into nine sections, such as “As Old as You Feel,” “Laughter: The Best Prescription,” and “Aged to Perfection.” <i>So Who’s Counting?</i> is all about aging with gusto and celebrating what lies ahead.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erin McHugh, Emily Luchetti
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?353adc46